var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"download-pdf"},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('hose.dimensions')))]),_c('div',{staticClass:"download-button",on:{"click":_vm.downloadPdf}},[_c('img',{attrs:{"src":_vm.getImage('hose/Pdf-file.svg')}}),_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.$t('hose.download')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }